import { FunctionComponent } from 'react';
import SolutionAdvantageWrapper from './solutionAdvantage.style';

const SolutionAdvantage: FunctionComponent = () => {
  const solutionAdvantages = [
    {
      title: '선결제를 통한 의뢰인 노쇼 방지',
      description:
        '예약 시간이 임박했을 경우에는 의뢰인의 예약 취소가 불가능해지므로 노쇼로 인한 시간손실을 방지할 수 있습니다.',
    },
    {
      title: '자동 예약 관리로 줄어드는 예약 업무',
      description:
        '예약 전 과정을 로톡이 실시간으로 안내해드리기 때문에 변호사님 본연의 업무에 더욱 집중할 수 있습니다.',
    },
    {
      title: '온라인 결제 대행사 결제 수수료 할인',
      description:
        '로톡은 상담에 대한 어떠한 수수료도 받지 않기 때문에, 온라인 결제 대행사의 결제 수수료가 할인됩니다.',
    },
    {
      title: '의뢰인의 상담 내용 사전 검토 가능',
      description:
        '의뢰인이 상담 내용을 입력하여 전달드리기 때문에 변호사님께서 사전에 사건내용을 검토 하실 수 있습니다.',
    },
  ];
  return (
    <SolutionAdvantageWrapper>
      <div className="solutionadvantage--header">
        <p className="solutioncomp--subtitle">Advantage</p>
        <p className="solutioncomp--title">어떤 점이 좋은가요?</p>
      </div>
      <div className="solutionadvantage--body">
        <div className="solutionadvantage--list">
          {solutionAdvantages.map((advantage, index) => (
            <div className="solutionadvantage--item" key={index}>
              <p className="solutionadvantage--item-title">{advantage.title}</p>
              <p className="solutionadvantage--item-desc">{advantage.description}</p>
            </div>
          ))}
        </div>
      </div>
    </SolutionAdvantageWrapper>
  );
};

export default SolutionAdvantage;
